// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"6935b270","257":"c6f7ee27","729":"c6f7ee27"}[chunkId] + ".chunk.css";
};